<template>
    <div>
        <Mainlayout></Mainlayout>
        <!-- <div class="h-100">
            <div>
                <CCol sm="12" class="bg-white h-100">
                    <br /><br /> <br /><br />
                    <CRow class="h-100 align-items-center">
                        <CCol sm="12" v-if="selectedVideo" class="mb-2">
                            <video controls autoplay muted class="full-video" :src="selectedVideo" width="100%"></video>
                        </CCol>
    
                        <CCol sm="4" class="video-thumbnail-container">
                            <video @click="playVideo(video1)" :src="video1" class="video-thumbnail" width="100%"></video>
                        </CCol>
                        <CCol sm="4" class="video-thumbnail-container">
                            <video @click="playVideo(video2)" :src="video2" class="video-thumbnail" width="100%"></video>
                        </CCol>
                        <CCol sm="4" class="video-thumbnail-container">
                            <video @click="playVideo(video3)" :src="video3" class="video-thumbnail" width="100%"></video>
                        </CCol>
                    </CRow>
                </CCol>
            </div>
        </div> -->


        <CCol sm="12" class="bg-white">
            <CRow>
                <CCol sm="12" class="mb-5">
                    <h3 class="custom-40px-600 text-center mt-5 mb-5">
                        <br />
                        How to use Interviewrr
                    </h3>
                        <CRow>
    
                            <CCol sm="12">
                                <video controls autoplay class="full-video" :src="selectedVideo" width="100%" style="border-radius:20px"></video>
                            </CCol>
                            <CCol sm="12" class="mt-2">
                                <CRow>
                                    <CCol sm="4">
                                        <div class="image-container">
  <!-- Center image -->
  <img src="../assets/img/v2.png" alt="Video thumbnail" class="video-thumbnail" />
  
  <!-- Play button overlay -->
  <div class="play-overlay">
    <img src="../assets/img/Pause.png" alt="Play button" class="play-button" @click="playVideo(video1)"/>
    <p class="guide-text font-color-f9f9f9 mt-3">Guide for Candidate</p>
  </div>
</div> </CCol>
                                    <CCol sm="4">
                                        <div class="image-container">
  <!-- Center image -->
  <img src="../assets/img/v3.png" alt="Video thumbnail" class="video-thumbnail" />
  
  <!-- Play button overlay -->
  <div class="play-overlay">
    <img src="../assets/img/Pause.png" alt="Play button" class="play-button" @click="playVideo(video2)"/>
    <p class="guide-text font-color-f9f9f9 mt-3">Guide for Company</p>
  </div>
</div>
                                    </CCol>
                                    <CCol sm="4">
                                        <img src="../assets/img/v4.png" style="max-width:100%" @click="playVideo(video3)"/>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                </CCol>
            </CRow>
        </CCol>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bgline.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import video1 from "../assets/img/intro.mp4";
import video2 from "../assets/img/video1.mp4";
import video3 from "../assets/img/video1.mp4";

export default {
    name: "Login",
    components: {
        Mainlayout,
    },
    data() {
        return {
            selectedVideo: video1,
            video1,
            video2,
            video3,
        };
    },
    methods: {
        playVideo(videoUrl) {
            this.selectedVideo = videoUrl;
            // Wait for the DOM to update and then play the video
            this.$nextTick(() => {
                const videoElement = this.$refs.mainVideo;
                if (videoElement) {
                    videoElement.load(); // Reload the video
                    videoElement.play(); // Programmatically play
                }
            });
        },
    },
};
</script>

<style scoped>
.h-100-page {
    height: 100vh;
    /* Full viewport height */
    overflow: hidden;
    /* Prevent scrolling */
    display: flex;
    flex-direction: column;
}

.h-100 {
    height: 100%;
    /* Ensures child elements take full height */
}
</style>